
import { computed, reactive, ref } from "vue";
import validate from "@/utils/validate";
import { visitorService } from "@/service";
import moment from "moment";
import { useRoute } from "vue-router";
import router, { RouterName } from "@/router";
import { Dialog } from "vant";
export default {
  setup() {
    const route = useRoute();

    const visitorInfo = reactive({
      person_lists: [],
      person_num: 0,
      visitor_token: ""
    });

    const defaultForm = {
      name: "",
      mobile: "",
      email: "",
      car_number: ""
    };

    const personList = ref([{ key: new Date().getTime(), ...defaultForm }]);

    const addPerson = () => personList.value.push({ key: new Date().getTime(), ...defaultForm });

    const deletePerson = (index: number) => personList.value.splice(index, 1);

    const onSubmit = async () => {
      try {
        const list = personList.value.map(i => ({
          name: i.name,
          mobile: i.mobile,
          email: i.email,
          car_number: i.car_number
        }));
        const { data } = await visitorService.my_visitor_perfect({
          h5_code: route.query.h5_code,
          visitor_token: visitorInfo.visitor_token,
          person_lists: JSON.stringify(list)
        });

        router.push({
          name: RouterName.VISITOR_SUCCESS,
          query: { tip: data.message }
        });
      } catch (error) {
        console.log(error);
        const err = error as any;
        if (err.state == "002") tpLose(err.message);
        if (err.state == "014") {
          Dialog({
            title: "提示",
            message: err.message,
            confirmButtonColor: "#3d6eeb"
          });
        }
      }
    };

    const tpLose = (tip: any) => {
      router.replace({
        name: RouterName.VISITOR_LOSE_EFFICACY,
        query: { tip }
      });
    };

    const getDetail = async () => {
      try {
        const { data } = await visitorService.my_visitor_info({ h5_code: route.query.h5_code });
        Object.assign(visitorInfo, data.data);
      } catch (error) {
        const err = error as any;
        tpLose(err.message);
      }
    };
    const number = computed(() => Number(visitorInfo.person_num) - visitorInfo.person_lists.length);

    getDetail();

    return {
      moment,
      addPerson,
      deletePerson,
      onSubmit,
      validate,
      number,
      personList
    };
  }
};
